export const addedProduct = [
  {
    path: `/AddedProduct`,
    name: `AddedProduct`,
    redirect: `/AddedProduct/added/:groupId`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/AddedProduct/added/:groupId/:projectId/:groupName/:isService/:groupDistinguish',
        name: 'AddedProduct/added',
        component: () => import('@/views/addedproduct/AddedProduct')
      },
      {
        path: '/AddedProduct/replace/:subId/:groupId/:projectId/:groupName/:isService/:itemId/:productCode/:productName/:productName/:productName/:subPropertyCode/:subProductCode/:optionalType/:productSeriesId/:propertyCode',
        name: 'ReplaceAddedProduct',
        component: () => import('@/views/addedproduct/ReplaceProductItem')
      }
    ]
  }
];
